// const cols = document.documentElement.clientWidth / 8
let data = {
    name: 'Empty',
    author: '',
    bg: '#333333',
    layout: [],
}
export default data